module.exports = __webpack_public_path__ + "img/learnModel-Pic.e2b466d3.png";